// Effective-entitlements evaluator for the client.
//
// MIRROR — the canonical implementation lives in
// packages/functions/shared/entitlements.py (effective_entitlements +
// FREE_ENTITLEMENTS). Only the tiny read-side comparison is mirrored here
// (grace expiry + missing-doc fallback); derivation (grace windows,
// grandfather floors) stays server-side in the Stripe webhook. Keep in sync.
//
// graceExpiresAt and nowSeconds are epoch seconds.

export const RETENTION_FREE_30D = 'free_30d';
export const RETENTION_SUBSCRIBER_PERSIST = 'subscriber_persist';

export const FREE_ENTITLEMENTS = {
  tier: 'free',
  storageGb: 2,
  monthlyCredits: 0,
  watermarkRemoval: false,
  retentionClass: RETENTION_FREE_30D,
  seatCount: 1,
};

export function evaluateEntitlements(userData, nowSeconds) {
  const data = userData || {};
  const entitlements = data.entitlements;

  let effective;
  if (!entitlements) {
    effective = { ...FREE_ENTITLEMENTS };
  } else {
    const status = (data.subscription || {}).status;
    const graceExpiresAt = entitlements.graceExpiresAt;
    const graceExpired =
      graceExpiresAt != null && status !== 'active' && nowSeconds >= graceExpiresAt;
    if (graceExpired) {
      effective = { ...FREE_ENTITLEMENTS };
    } else {
      effective = { ...FREE_ENTITLEMENTS, ...entitlements };
      delete effective.floors;
      delete effective.updatedAt;
    }
  }

  return { ...effective, isEffectivelyFree: effective.tier === 'free' };
}
